import { createResourceApi } from 'resources/ResourceApi';
import { FurnishingApiItem } from 'typings/api';

export default createResourceApi<FurnishingApiItem>('furnishings');
